import React from 'react';
import { Card, Tooltip, Space } from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
const TableItem = (title, value, unit, tip, isTailDivider, key) => {
  return (
    <div
      key={key}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}
    >
      <span
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 130,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: 14 }}>{title}</span>
          {tip ? (
            <span style={{ fontSize: 14, marginLeft: 10 }}>
              <Tooltip title={tip}>
                <QuestionCircleTwoTone />
              </Tooltip>
            </span>
          ) : (
            ''
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'baseline', marginTop: 10 }}>
          <span style={{ fontSize: 26, fontWeight: 'bold' }}>{value}</span>
          <span style={{ fontSize: 14, marginLeft: 2 }}>{unit}</span>
        </div>
      </span>
      {isTailDivider ? (
        <span style={{ background: '#e4e4e4', width: 1, height: 50 }}></span>
      ) : (
        ''
      )}
    </div>
  );
};
const TableTitle = (title, titleTip) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        background: '#f2f2f2',
        padding: 10,
      }}
    >
      <span>
        <Space>
          <label>{title}</label>
          {titleTip ? (
            <Tooltip title={titleTip}>
              <QuestionCircleTwoTone />
            </Tooltip>
          ) : (
            ''
          )}
        </Space>
      </span>
    </div>
  );
};
const RowTable = (props) => {
  // eslint-disable-next-line react/prop-types
  const { rowTableData = [], title } = props;
  return (
    <div
      style={{
        flex: 1,
        marginBottom: '10px',
      }}
    >
      <Card bodyStyle={{ padding: 0 }}>
        <div>{title ? <div>{TableTitle(title)}</div> : ''}</div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
          }}
        >
          {rowTableData.map((item, index) =>
            TableItem(
              item.title,
              item.value,
              item.unit,
              item.tip,
              item.isTailDivider,
              index,
            ),
          )}
        </div>
      </Card>
    </div>
  );
};
export default RowTable;
